URL={
  "list":"/sys/sysmng/resource/find",//列表
  "add":"/tenant/user/add",//新增 
  "moidfy":"/tenant/user/modify",//修改资源
  "FREEZE":"/tenant/user/freeze",//冻结租户
  "find":"/tenant/user/find",//查询租户
  "open":"/tenant/user/opentenantaccount"//租户管理-开户账号
}

/**
 * 加载平台资源 
 * @param {} data 
 * @param {*} cb 
 */
async function loadPlatTenantes(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.list,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

/**
 * 查询单条租户信息
 * @param {*} data 
 * @param {*} cb 
 */
async function findModifyTenant(data,cb){
  debugger;
  let vm=this;
  if(!data){
      return;
  }
  vm.loadingBg = "rgba(255,255,255,0.5)";
  vm.loadingTxt = "数据处理中...";
  let resResult = await vm.$get(URL.find,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

/**
 * 新增租户信息
 * @param {*} data 
 * @param {*} cb 
 */
async function submitNewPlatTenant(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.add,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

async function submitModifyPlatTenant(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.moidfy,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

/**
 * 开通租户账号
 * @param {*} data 
 * @param {*} cb 
 */
async function submitOpenTenantAccount(data,cb){
  let vm=this;
  if(!data){
      return;
  }
  vm.loadingBg = "rgba(255,255,255,0.5)";
  vm.loadingTxt = "数据处理中...";
  let resResult = await vm.$post(URL.open,data);
  if(cb&&resResult){
    cb(resResult);
  }
}

/**
 * 调整租户权限
 * @param {*} data 
 * @param {*} cb 
 */
async function submitPermiAdjust(data,cb){
  let vm=this;
  if(!data){
      return;
  }
  vm.loadingBg = "rgba(255,255,255,0.5)";
  vm.loadingTxt = "数据处理中...";
  let resResult = await vm.$post(URL.open,data);
  if(cb&&resResult){
    cb(resResult);
  }
}





//export const URL_PLATFORM_RESOURCE=URL;

export default{
  loadPlatTenantes,
  findModifyTenant,
  submitNewPlatTenant,
  submitModifyPlatTenant,
  submitOpenTenantAccount,
  submitPermiAdjust
}


